import { jsx as _jsx } from "react/jsx-runtime";
import { Button, IconButton, Box } from "@mui/material";
export const UploadFileIconButton = (props) => {
    return _jsx(Box, { sx: { borderRadius: "50%", backgroundColor: "common.white" }, children: _jsx(IconButton, Object.assign({ size: "large" }, props)) });
};
export const UploadFileButton = (props) => {
    return _jsx(Box, { sx: { borderRadius: "18px", backgroundColor: "common.white" }, children: _jsx(Button, Object.assign({}, props)) });
};
//# sourceMappingURL=UploadFileButtons.js.map